import { useRef, useEffect } from 'react';

export function useLatestValue<T>(value: T) {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
